import {Pipe, PipeTransform} from "@angular/core";

@Pipe({ name: 'properties',  pure: false })
export class PropertiesPipe implements PipeTransform {
  transform(value: any, args: any[] = null): any {
    return Object.keys(value).map(key => { return { key: key, value: value[key]}; });
  }
}



// WEBPACK FOOTER //
// ./src/pipes/properties.pipe.ts